module.exports = __webpack_public_path__ + "media/images/version_merge/banks/diners_club_logo-ca4e74870829946f6b89710d33a85c9c.png";